import { createContext, useContext } from "react";

export const PreferredLanguageContext = createContext(null);

export const usePreferredLanguageContext = () => {
    const result = useContext(PreferredLanguageContext);

    return result;
}